import { useAppContext, useConfigContext } from '@fe-core';
import { publishHeaderConfig } from '@fe-core-events';
import { useApplyBranding } from '@fe-core-ui/src';
import { useHeaderConfig } from '@fe-learner-common/hooks';
import { useHeaderBranding } from '@hooks/useHeaderBranding';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDocumentTitle } from 'usehooks-ts';

export const useApplyPageConfig = () => {
  const intl = useIntl();
  const { config } = useConfigContext();
  const { isLoading, branding } = useAppContext();

  useApplyBranding(branding, config.aleTheme);
  useHeaderBranding({ branding });
  useDocumentTitle(
    isLoading ? '' : intl.formatMessage({ id: 'catalog.title' }),
  );

  const headerConfig = useHeaderConfig({
    enabled: !isLoading,
    activeItem: 'catalog',
  });

  useEffect(() => {
    if (!headerConfig || !headerConfig.items) return;

    publishHeaderConfig(headerConfig);
  }, [headerConfig]);
};
